export const getMarketingEnv = (joyEnv: Window['joyEnv']) => {
  if (joyEnv && joyEnv.JOY_CONFIG_MARKETING_WEBSITE_HOSTNAME) {
    return `${joyEnv.JOY_CONFIG_MARKETING_WEBSITE_PROTOCOL}://${joyEnv.JOY_CONFIG_MARKETING_WEBSITE_HOSTNAME}:${
      joyEnv.JOY_CONFIG_MARKETING_WEBSITE_PORT
    }`;
  } else {
    console.error('Environment not found. Falling back to rehearsal.');
    return `https://rehearsal.withjoy.com`;
  }
};
